<template>
    <div class="vetted-statements" id="vetted-statements">

        <b-modal :active.sync="modalForm.active" has-modal-card>
            <modal-form :data="modalForm.data" :mode="modalForm.mode" :organization="organization" @create-success="onModalFormCreateSuccess" @update-success="onModalFormUpdateSuccess"></modal-form>
        </b-modal>

        <b-modal :active.sync="modalConfigure.active" has-modal-card>
            <modal-configure :organization="organization" @submit-success="onModalConfigureSubmitSuccess" @delete-success="onModalConfigureDeleteSuccess"></modal-configure>
        </b-modal>

        <!-- <div class="box is-shadowless"> -->

            <h1 class="title is-3" >
                Vetted Notes
                <div class="buttons is-pulled-right">
                    <button class="button is-danger" @click="onDeleteVettedStatements" v-if="checkedVettedStatements.length">
                        Delete
                    </button>
                    <button class="button is-info" @click="openModalForm()">
                        Create
                    </button>
                    <button class="button is-info" @click="openModalConfigure()">
                        Configure
                    </button>
                </div>
            </h1>

            <filters @filter="onFilter" ref="filters"></filters>

            <b-table striped hoverable :data="vettedStatements" :loading="loading" backend-pagination :total="pagination.total" :per-page="pagination.perPage" :checked-rows.sync="checkedVettedStatements" checkable>
                <template slot-scope="props">
                    <b-table-column v-for="(column, index) in columns" :key="index" :field="column.field" :label="column.label" :class="column.meta.class || ''">
                        {{ getObjectValue(props.row, column.meta.valuePath) }}
                    </b-table-column>
                    <b-table-column label="" class="no-wrap">
                        <a href="#" class="button is-small" @click.prevent="openModalForm(props.row.vettedOrderActivity, 'update')">EDIT</a>
                    </b-table-column>
                </template>
                <template slot="empty">
                    <div id="idle_height_test" class="content has-text-grey has-text-centered">
                        <p>No results</p>
                    </div>
                </template>
            </b-table>

            <br>

            <b-pagination :total="pagination.total" :current.sync="pagination.currentPage" :per-page="pagination.perPage" aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page" @change="onPageChange"></b-pagination>

        <!-- </div> -->

    </div>
</template>

<script>

    import ModalForm from "./partials/modalForm";
    import ModalConfigure from "./partials/modalConfigure";
    import Filters from "./partials/filters";
    import { JsonDenormalizer } from "@/helpers/JsonDenormalizer.js";
    import { VettedStatementRelationshipService } from "@/services/vettedStatementRelationship.service.js";

    export default {
        props: {
            organization: {
                type: Object,
                required: true
            }
        },

        components: {
            ModalForm,
            ModalConfigure,
            Filters
        },

        data: () => ({

            vettedStatements: [],
            checkedVettedStatements: [],

            columns: [
                /*
                {
                    field: "group",
                    label: "Group",
                    meta: {
                        valuePath: "group.name",
                        class: "no-wrap"
                    }
                },
                */
                {
                    field: "status",
                    label: "Status",
                    meta: {
                        valuePath: "orderStatus.name",
                        class: "no-wrap"
                    }
                },
                {
                    field: "problem",
                    label: "Problem",
                    meta: {
                        valuePath: "problemCode.name",
                        class: "no-wrap"
                    }
                },
                {
                    field: "shortText",
                    label: "Short Name",
                    meta: {
                        valuePath: "vettedOrderActivity.shortText"
                    }
                },
                {
                    field: "longText",
                    label: "Long Name",
                    meta: {
                        valuePath: "vettedOrderActivity.longText"
                    }
                }
            ],

            filters: {},

            pagination: {
                perPage: 100,
                total: 0,
                currentPage: 1
            },

            modalForm: {
                props: null,
                active: false
            },

            modalConfigure: {
                active: false
            },

            loading: false

        }),

        mounted() {

            this.fetchVettedStatements();

            setTimeout(() => {
                var idle_height_test = document.getElementById('container').offsetHeight ;
                document.getElementById('idle_height_test').style.height = this.$store.state.idleHeight - idle_height_test + 'px';
            }, 1000);

        },

        methods: {

            fetchVettedStatements(page = 1) {

                this.loading = true;

                const query = Object.assign(
                    {
                        include: "vettedOrderActivity,group,orderStatus,problemCode",
                        orderBy: "vetted_order_activities.short_text",
                        page
                    },
                    this.filters
                );

                VettedStatementRelationshipService.all(query).then(response => {

                    this.vettedStatements = JsonDenormalizer.denormalize(response);
                    this.pagination.perPage = response.meta.pagination.per_page;
                    this.pagination.total = response.meta.pagination.total;
                    this.pagination.currentPage = response.meta.pagination.current_page;
                    this.loading = false;

                    //Not syncing when replacing the table data
                    this.checkedVettedStatements = [];

                });

            },

            onFilter(filters) {
                this.filters = filters;
                this.fetchVettedStatements();
            },

            onPageChange(page) {
                this.fetchVettedStatements(page);
            },

            getObjectValue(obj, path) {
                return path.split(".").reduce((acc, val) => {
                    acc = acc[val];
                    return acc;
                }, obj);
            },

            openModalConfigure() {
                this.$set(this.modalConfigure, "active", true);
            },

            onModalConfigureSubmitSuccess() {
                this.fetchVettedStatements(this.pagination.currentPage);
            },

            onModalConfigureDeleteSuccess() {
                this.$refs.filters.$refs.selectVettedStatement.fetchOptions();
            },

            openModalForm(data = null, mode = "create") {
                this.$set(this.modalForm, "data", data);
                this.$set(this.modalForm, "mode", mode);
                this.$set(this.modalForm, "active", true);
            },

            onModalFormCreateSuccess() {
                this.$refs.filters.$refs.selectVettedStatement.fetchOptions();
            },

            onModalFormUpdateSuccess() {
                this.$refs.filters.$refs.selectVettedStatement.fetchOptions();
                this.fetchVettedStatements(this.pagination.currentPage);
            },

            onDeleteVettedStatements() {
                this.$buefy.dialog.confirm({
                    title: "Confirm",
                    message: "Are you sure you want to <b>delete</b> the selected vetted statement(s)?",
                    confirmText: "Delete",
                    type: "is-danger",
                    hasIcon: true,
                    onConfirm: () => {
                        //Should be a computed property, but checkedVettedStatements is not reactive
                        const ids = this.checkedVettedStatements.map(row => row.id);
                        this.deleteVettedStatements(ids);
                    }
                });
            },

            deleteVettedStatements(ids) {

                this.loading = true;

                VettedStatementRelationshipService.delete({ ids }).then(
                    response => {
                        this.$buefy.toast.open({
                            message: "Vetted statement(s) has been deleted",
                            type: "is-info",
                            position: "is-top-right"
                        });
                        this.fetchVettedStatements(this.pagination.currentPage);
                    },
                    err => {
                        this.loading = false;
                    }
                );

            }

        }

    };

</script>

<style scoped>
    .no-wrap {
        white-space: nowrap;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/VettedStatement/list/index.vue